<div class="modal-header d-flex justify-content-between align-items-center">
    <h4 class="modal-title">Filter template list</h4>
    <svg (click)="closeModal()" class="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
        viewBox="0 0 24 24" fill="currentColor">
        <path
            d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z">
        </path>
    </svg>
</div>
<div class="modal-body pt-3">
    <div class="filter-card-list">
        <div class="row row--gutter">
            <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let template of filterTemplateList; let i = index">
                <div class="filter-card">
                    <span class="filter-card-title">{{ template.name }}</span>
                    <button class="delete-icon" (click)="showConfirm(i)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#dc3545">
                            <path
                                d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z">
                            </path>
                        </svg>
                    </button>
                    <div *ngIf="template.showConfirm" class="confirm d-flex justify-content-between align-items-center">
                        <p class="mt-0 mb-0">Are you sure?</p>
                        <span class="d-flex">
                            <span class="d-flex justify-content-start align-items-center"
                                (click)="deleteTemplate(template.filter_id)">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"
                                    fill="#a5ca00">
                                    <path
                                        d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z">
                                    </path>
                                </svg>
                                <p class="mr-2 mb-0 confirm-btn">Yes</p>
                            </span>
                            <span class="d-flex justify-content-start align-items-center" (click)="hideConfirm(i)">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"
                                    fill="#dc3545">
                                    <path
                                        d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z">
                                    </path>
                                </svg>
                                <p class="mr-2 mb-0 confirm-no">No</p>
                            </span>
                        </span>
                        <!-- <button type="button" (click)="deleteTemplate(template.filter_id)"
                            class="btn btn-secondary confirm-btn" data-dismiss="modal">Yes</button>
                        <button type="button" (click)="hideConfirm(i)" class="btn btn-secondary confirm-btn-no"
                            data-dismiss="modal">No</button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>